<!--
* 组件名 : 全屏绘画图组件
* 开发者 : HN
*
* 参数:
*  paintPath            { String }  required - 手绘图非完整路径
*  fullScreenPaintData  { Object }           - API里的数据
*  {
*   audio: Object（音频数据）
*   description: '这里面是描述'
*  }
*
* 事件:  null
* 
*
-->
<template>
  <section class="v-full-screen-paint" :class="wrapClass" ref="wrap">
    <v-background auto-height>
      <v-img
        class="paint-img"
        :path="paintPath"
        @load="on_image_load($event)"
        ref="paintImg"
      />
    </v-background>
    <div class="fixed-box" ref="fixedBox">
      <fixedPlayer
        ref="fixedPlayer"
        v-if="
          Object.keys(fullScreenPaintData).includes('audio') &&
          fullScreenPaintData.audio.lists[0].audioUri !== ''
        "
        :autoplay="false"
        :audio="fullScreenPaintData.audio"
        @showLyricsPlayer="show_lyrics_player"
        @showMiniPlayer="show_mini_player"
      />
      <pictureGraph
        ref="vPictureGraph"
        v-if="Object.keys(fullScreenPaintData).includes('description')"
        :desc="fullScreenPaintData.description"
      />
    </div>
    <v-btn class-name="picture-view-btn" @btnClick="on_open_paint_viewer">
      <v-icon>zoom_in</v-icon>
    </v-btn>
    <div class="fix-box">&nbsp;</div>
  </section>
</template>

<script>
import { uuidv4 } from "utils/util";
import pictureGraph from "./components/picture-graph/index";
import fixedPlayer from "./components/fixed-player/index";

export default {
  name: "v-full-screen-paint",
  components: {
    pictureGraph,
    fixedPlayer,
  },
  props: {
    paintPath: {
      type: String,
      required: true,
    },
    fullScreenPaintData: Object,
  },
  data() {
    this.uniqueEventName = `resize.${uuidv4()}`;
    return {
      wrapClass: ["under-pin"],
    };
  },
  beforeDestroy() {
    $(window).off(this.uniqueEventName);
  },
  methods: {
    on_parallax_pined_top() {
      //  8000 后, 删除hint
      setTimeout(() => {
        $(this.$refs.wrap).find(".hint").remove();
      }, 8000);
    },
    on_image_load(ev) {
      $(window).on(this.uniqueEventName, () => {
        let img = this.$refs.paintImg.$el;
        let { originHeight, originWidth } = img.dataset;
        $(img)
          .parents(".v-full-screen-paint")
          .get(0).dataset.direction = img.dataset.direction =
          originWidth / originHeight > $(window).width() / $(window).height()
            ? "vertical"
            : "horizontal";
      });
      setTimeout(() => $(window).trigger(this.uniqueEventName), 600);
    },

    on_parallax_un_pin(payload) {
      let { top } = $(this.$refs.wrap)
        .parents(".v-page")
        .get(0)
        .getBoundingClientRect();
      let offsetTop = $(this.$refs.wrap)
        .parents(".v-page")
        .hasClass("link-above")
        ? top
        : top + $(window).height();

      if (offsetTop >= 0) {
        this.wrapClass = ["under-pin"];
      } else {
        this.wrapClass = ["above-pin"];
      }
    },

    show_lyrics_player() {
      $(this.$refs.vPictureGraph.$refs.pictureGraph).velocity(
        { opacity: 0, translateX: this.$P.isRtl ? 200 : -200, translateZ: 0 },
        {
          easing: "easeInOutCubic",
          duration: 320,
          delay: 40,
        }
      );
    },

    show_mini_player() {
      $(this.$refs.vPictureGraph.$refs.pictureGraph).velocity(
        this.$P.isRtl
          ? "transition.slideRightBigIn"
          : "transition.slideLeftBigIn",
        {
          easing: "cubic-bezier(.12,.81,.91,.3)",
          duration: 320,
          delay: 360,
        }
      );
    },
    /**
     * 调用手绘图查看器
     */
    on_open_paint_viewer() {
      this.$paintViewer({
        carousel: [
          {
            max: this.paintPath,
          },
        ],
        current: 0,
        transitionName: "fade",
      });
    },
  },
};
</script>

<style lang="scss">
.v-page:not(.link-above) {
  .fix-box {
    height: 100vh;
    pointer-events: none;
  }
}
.v-page {
  &[data-pined="true"] {
    .v-full-screen-paint:not([data-direction="vertical"]) {
      .fixed-box,
      .picture-view-btn {
        position: fixed;
        opacity: 1;
        transform: translateY(0px);
      }
    }
  }
  &[data-unpin="true"] {
    .under-pin {
      .fixed-box,
      .picture-view-btn {
        position: fixed;
        opacity: 0;
        transform: translateY(40px);
        pointer-events: none !important;
      }
    }
  }
  .v-full-screen-paint[data-direction="vertical"] {
    .fixed-box,
    .picture-view-btn {
      opacity: 1;
      transform: translateY(0px) translateZ(0);
      position: absolute;
      pointer-events: unset !important;
    }
  }
}
.v-full-screen-paint {
  position: relative;
  width: 100%;
  height: auto;
  line-height: 0;
  .paint-img {
    width: 100%;
    object-fit: cover;
    object-position: center;
    &[data-direction="vertical"] {
      width: auto;
      height: 100.1vh;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .fixed-box {
    position: absolute;
    transition: 0.3s ease-in-out;
    left: 40px;
    bottom: 24px;
  }
  .picture-view-btn {
    position: absolute;
    right: 40px;
    bottom: 24px;
  }
}

body.rtl {
  .v-full-screen-paint {
    .fixed-box {
      right: 40px;
      left: unset;
    }
    .picture-view-btn {
      left: 40px;
      right: unset;
    }
    .paint-img[data-direction="vertical"] {
      right: 50%;
      transform: translateX(50%);
      left: unset;
    }
  }
}
</style>
